import React from "react";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import Sidebar from "../../Navigation/Sidebar/Sidebar";
import Button from "@mui/material/Button";
import { useNavigate } from "react-router-dom";
import leftArrow from "../../../assests/leftArrow.svg";
import "./CohortUpdateComponentPartner.css";

const CohortUpdateComponent = (props) => {
  const navigate = useNavigate();
  const goback1 = () => {
    navigate(-1);
  };

  return (
    <div className="main-container">
      <Sidebar />

      <div className="content-container">
        <div className="header">
          <h2>
            <img
              onClick={goback1}
              className="back-arrow"
              src={leftArrow}
              alt="Go Back"
            />
            Edit Cohort
          </h2>
        </div>

        <div className="form-wrapper">
          {/* Add VM Section */}
          <div className="form-section">
            <Box className="form-box">
              <TextField
                fullWidth
                label="Add VMID"
                name="newNameAttribute"
                value={props.newNameAttribute}
                onChange={props.handleInputChange}
                error={props.inputError}
                className="input-field"
              />
              <Button className="form-button" onClick={props.vmAdded}>
                ADD
              </Button>
            </Box>
          </div>

          {/* Remove VM Section */}
          <div className="form-section">
            <Box className="form-box">
              <div className="vm-id-box">
                <p>VMIDs: {props.vmIdList.join(", ")}</p>
              </div>
              <TextField
                fullWidth
                label="Remove VMID"
                name="machines"
                value={props.removeVmid}
                onChange={props.handleChangeRemoveVmid}
                className="input-field"
              />
              <Button className="form-button" onClick={props.vmDeleted}>
                REMOVE
              </Button>
            </Box>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CohortUpdateComponent;
